const defaultFont = { size: 14, style: 'normal', family: 'Helvetica Neue' }
const warningFont = { size: 12, style: 'bold', family: 'Helvetica Neue' }

const plugin = (chart, font = {}) => {
    const ctx = chart.ctx
    const chartArea = chart.chartArea;
    const selectedFont = { ...defaultFont, ...font }

    chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i)
        const hidden = (meta.hidden === null) ? chart.data.datasets[i].hidden : meta.hidden;
        if (!hidden) {
            meta.data.forEach((element, index) => {
                ctx.fillStyle = dataset.borderColor
                ctx.font = `${selectedFont.style} ${selectedFont.size}px ${selectedFont.family}`
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'

                let inclination = (dataset.data[index].metadata || {}).inclination
                const inclinationWarning = (dataset.data[index].metadata || {}).inclinationWarning

                if (inclination) {
                    //draw rectangle with white inclination value
                    const x = (meta.data[index]._model.x + meta.data[index - 1]._model.x) / 2
                    const y = (meta.data[index]._model.y + meta.data[index - 1]._model.y) / 2
                    const padding = 4;
                    const diameter = 6;
                    const width = ctx.measureText(inclination).width;
                    if (chartArea.top < y && chartArea.bottom > y && chartArea.left < x && chartArea.right > x) {
                        ctx.fillRect(x - width / 2 - padding, y - selectedFont.size / 2 - padding, width + 2 * padding, selectedFont.size + 2 * padding);
                        ctx.fillStyle = '#ffffff';
                        ctx.fillText(inclination, x, y);

                        if (inclinationWarning) {
                            //draw red circle with white exclamation mark
                            ctx.fillStyle = '#ff0000'
                            ctx.font = `${warningFont.style} ${warningFont.size}px ${warningFont.family}`
                            ctx.beginPath();
                            ctx.arc(x + width / 2 + padding + 1, y - selectedFont.size / 2 - padding - 1, diameter, 0, 2 * Math.PI);
                            ctx.fill();
                            ctx.fillStyle = '#ffffff';
                            ctx.fillText("!", x + width / 2 + padding + 1, y - selectedFont.size / 2 - padding + 0.25);
                        }
                    }



                }
            })
        }
    })
}

export default plugin



// WEBPACK FOOTER //
// ./App/components/modules/chart-plugins/drawInclinationLabel.js